export default {"src":"/_next/static/media/customer-boom.7c1d8269.svg","height":57,"width":224};